import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './layouts/Navbar';
import Footer from './layouts/Footer';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import AdminSidebar from './admin/AdminSidebar';
import Companies from './admin/admin/Companies';
import Branches from './admin/admin/Branches';
import Employee from './admin/admin/Employee';
import Inventory from './admin/subadmin/Inventory';
import EmployeeA from './admin/subadmin/attendance/EmployeeA';
import Accounts from './admin/subadmin/Accounts';
import EditCompany from './admin/admin/EditCompany';
import EditBranch from './admin/admin/EditBranch';
import EditEmp from './admin/admin/EditEmp';
import PartyDetail from './admin/subadmin/PartyDetail';
import Purchase from './admin/subadmin/purchase/Purchase';
import Order from './admin/subadmin/purchase/Order';
import Enquiry from './admin/subadmin/purchase/Enquiry';
import Quotation from './admin/subadmin/purchase/Quatation';
import Return from './admin/subadmin/purchase/Return';
import AddEmployee from './admin/subadmin/attendance/EmployeeA';
import EmployeeAttendence from './admin/subadmin/attendance/EmployeeAtteendence';
import AttReport from './admin/subadmin/attendance/AttReport';
import PayHead from './admin/subadmin/attendance/PayHead';
import Role from './admin/admin/Role';
import State from './admin/admin/State';
import GenPayroll from './admin/subadmin/attendance/GenParroll';
import PayheadAmt from './admin/subadmin/attendance/PayheadAmt';
import PartyMaster from './admin/admin/Party_Master';
import AccountMaster from './admin/admin/Account_Master';
import LeaveMaster from './admin/subadmin/attendance/LeaveMaster';
import Leave from './admin/subadmin/attendance/Leave';
import PageNotFound from './pages/PageNotFound';
import MaterialIssue from './admin/subadmin/inventory_issue/materail_isssue';
import StockTransfer from './admin/subadmin/inventory_issue/stock_transfer';
import AddHoilday from './admin/admin/HRMS/AddHoilday';
import { LoadingProvider } from './context/LoadingContext';
import { PermissionProvider } from './context/userAccess';
import LeaveRequest from './admin/admin/HRMS/LeaveRequest';
import PORequistion from './admin/subadmin/inventory_issue/purchase_requistion';
import MaterialReceipt from './admin/subadmin/inventory_issue/materail_receipt';
import Report from './admin/subadmin/inventory_issue/Report';
import GodownMaster from './admin/subadmin/inventory_issue/Godown';
import Loan from './admin/admin/HRMS/Loan';
import NoticeBoard from './admin/admin/HRMS/NoticeBoard';
import HrDoctypeMaster from './admin/admin/master/HrDoctypeMaster';
import PayrollReport from './admin/subadmin/attendance/PayrollReport';





import AllDocument from './admin/admin/HRMS/documents/AllDocument';
import SalaryIncrement from './admin/admin/HRMS/documents/SalaryIncrement';
import JobOffer from './admin/admin/HRMS/documents/JobOffer';
import Confirmation from './admin/admin/HRMS/documents/Confirmation';
import Separation from './admin/admin/HRMS/documents/Separation';
import Appointment from './admin/admin/HRMS/documents/Appointment';
import Posting from './admin/admin/HRMS/documents/Posting';
import TerminationNotice from './admin/admin/HRMS/documents/TerminationNotice';
import ChangeDesignation from './admin/admin/HRMS/documents/ChangeDesignation';
import CodeConduct from './admin/admin/HRMS/documents/CodeConduct';
import DisciplinaryWarning from './admin/admin/HRMS/documents/DisciplinaryWarning';
import Appriciation from './admin/admin/HRMS/documents/Appriciation';
import Testimonial from './admin/admin/HRMS/documents/Testimonial';
import Advance from './admin/admin/HRMS/documents/Advance';
import Reference from './admin/admin/HRMS/documents/Reference';
import PerformaInvoice from './admin/admin/sales/PerformaInvoice';
import SaleInvoice from './admin/admin/sales/SaleInvoice';
import SaleQuotation from './admin/admin/sales/SaleQuotation';
import DeliveryChallan from './admin/admin/sales/DeliveryChallan';
import SaleReturn from './admin/admin/sales/SaleReturn';

import FollowUp from './admin/admin/CRM/FollowUp';
import SalesEnquiry from './admin/admin/CRM/SalesEnquiry';
import Complaint from './admin/admin/Services/Complaint';
import ComplaintTypeMaster from './admin/admin/master/ComplaintTypeMaster';
import Recharge from './admin/admin/Services/Recharge';
import ChargeMaster from './admin/admin/master/ChargeTypeMaster';
import UserRight from './admin/admin/userRight/UserRight';
import Warranty from './admin/admin/warraanty/warranty';
import FollowupStatus from './admin/admin/master/FollowupStatus';
import VendorCall from './admin/admin/Services/vendorCall/VendorCall';
import VendorCallStatusPage from './admin/admin/Services/vendorCall/VendorCallStatusPage';
import Batch_master from './admin/admin/Production/Batch_master';
import Bom_master from './admin/admin/Production/Bom_master';
import Matrerial_issuee_Production from './admin/admin/Production/Matrerial_issuee_Production';
import PrintItemDetail from './admin/subadmin/inventory_issue/PrintItemDetail';

import ServiceSchedule from './admin/admin/warraanty/PmsServiceSchedule';
import AMC from './admin/admin/AMC/AMC';
import Service_ReportPMS from './admin/admin/Services/Service_ReportPMS';
import WarrantyReport from './admin/admin/warraanty/WarrantyReport';
import AMCQuotation from './admin/admin/AMC/AMCQuotation';
import AMC_Report from './admin/admin/AMC/AMC_Report';
import SaleReport from './admin/admin/sales/SaleReport';
import DeniedCall from './admin/admin/FranchiseeAdmin/DeniedCall';
import FranchiseeArea from './admin/admin/FranchiseeAdmin/FranchiseeArea';
import CustomareCareDetail from './admin/admin/CustomareCare/CustomareCareDetail';
import AddDataCall from './admin/admin/CRM/AddDataCall';
import CallDetail from './admin/admin/TeamLeader/CallDetail';
import AllVerifiedCall from './admin/admin/CRM/AllVerifiedCall';
import TelleCaller from './admin/admin/TelleCaller/TelleCaller';
import RepairQuotation from './admin/admin/Services/RepairQuotation';
import RepairInvoice from './admin/admin/Services/RepairInvoice';
import BankPayment from './admin/admin/Account/BankPayment';
import CashPayment from './admin/admin/Account/CashPayment';
import BankReceipt from './admin/admin/Account/BankReceipt';
import CashReceipt from './admin/admin/Account/CashReceipt';
import CreditNode from './admin/admin/Account/CreditNode';
import DebitNote from './admin/admin/Account/DebitNote';
import JournalVoucher from './admin/admin/Account/JournalVoucher';
import ExpenseVoucher from './admin/admin/Account/ExpenseVoucher';
import ContraVoucher from './admin/admin/Account/ContraVoucher';
import CostCenter from './admin/admin/Costing/CostCenter';
import CostCategory from './admin/admin/Costing/CostCategory';
import CostCenterLink from './admin/admin/Costing/CostCenterLink';
import { PostOpening } from './admin/admin/recruitment/PostOpening';
import  MyApplications  from './admin/admin/recruitment/MyApplications';
import Careers from './pages/Careers';
import AccountReport from './admin/admin/Account/AccountReport';
import CRMReport from './admin/admin/CRM/CRMReport';
import DailtAttendence from './admin/admin/dailyAttendence/DailtAttendence';
import Banner from './admin/admin/Banner/Banner';
import Coupon from './admin/admin/master/Coupon';
import Technician_Verify from './admin/admin/CustomareCare/Technician_Verify';
import MessageMaster from './admin/admin/Messages/MessageMaster';
import ServiceReminder from './admin/admin/Messages/ServiceReminder';
import Payhead_Report from './admin/subadmin/attendance/Payhead_Report';
import Deperecaition_Method from './admin/admin/FixedAssets/Deperecaition_Method';
import Assets from './admin/admin/FixedAssets/Assets'

import ManageOrder from './admin/admin/Order/ManageOrder';
import Enquiry_From from './admin/admin/Cotact/Enquiry_From';
import Report_hrms from './admin/admin/HRMS/Report_hrms';
import PFReport from './admin/admin/Reports/PFReport';
import CostingReport from './admin/admin/Reports/CostingReport';
import Schedule from './admin/admin/master/Schedule';
import SalesDocuments from './admin/admin/sales/SalesDocuments';
import PurchaseDocument from './admin/subadmin/purchase/PurchaseDocument';
import InventoryDocument from './admin/subadmin/inventory_issue/InventoryDocument';
import CRMDocument from './admin/admin/CRM/CRMDocument';
import AMCDocument from './admin/admin/AMC/AMCDocument';
import ServiceDocuments from './admin/admin/Services/ServiceDocuments';
import AccountDocument from './admin/admin/Account/AccountDocument';
import FinancialYear from './admin/admin/master/FinancialYear';
import BankReconcilation from './admin/admin/Account/BankReconcilation';
import Appraisal_parameter from './admin/admin/Appraisal/Appraisal_parameter';
import AppraisalRating from './admin/admin/Appraisal/AppraisalRating';
import AppraisalType from './admin/admin/Appraisal/AppraisalType';
import Appraisal from './admin/admin/Appraisal/Appraisal';
import Setting from './admin/admin/master/Setting';
import Emi from './admin/admin/EMI/Emi';
import HSNCode from './admin/admin/master/HSNCode';
import GroupMaster from './admin/admin/master/GroupMaster';



const App = () => {
  const role = localStorage.getItem("role");
const permissions = JSON.parse(localStorage.getItem("permissions")) || {};

   const companyID = localStorage.getItem("companyID");
    const branchID = localStorage.getItem("branchID");
  const location = useLocation();
  const isAdminLoginPage = location.pathname === "/admin-login";

  const adminData = JSON.parse(localStorage.getItem("adminData"));
  const empData = JSON.parse(localStorage.getItem("empData"));
  const financialYear =localStorage.getItem("financial_year");


   
  return (
    <>
       
      <LoadingProvider>
        {/* Public site (non-admin) */}
        {!role && (
          <>
            {/* {!isAdminLoginPage && <Navbar />} */}
            <Routes>
              <Route exact path='/' element={<><Navbar /><Home /><Footer /></>} />
              <Route exact path='/privacy-policy' element={<><Navbar /><PrivacyPolicy /><Footer /></>} />
              <Route exact path='/contact' element={<><Navbar /><Contact /><Footer /></>} />
              <Route exact path='/careers' element={<><Navbar /><Careers/> <Footer /> </>}/>
              <Route exact path='/admin-login' element={<><AdminLogin adminData={adminData} /></>} />
              <Route exact path='*' element={<PageNotFound />} />
            </Routes>
            {/* {!isAdminLoginPage && <Footer />} */}
          </>
        )}


        {/*  (admin or superadmin) */}
        {role && (
          <>
            <AdminSidebar adminData={adminData} role={role}  permissions={permissions} />
            <Routes>
              <Route exact path='/' element={<AdminDashboard />} />
              {/* <Route exact path='/' /> */}
              <Route exact path='/admin/dashboard' element={<AdminDashboard  adminData={adminData} companyID={companyID} branchID={branchID} />} />

              {/* Superadmin-only pages */}
              {role === 'admin' && (
                <>
                  <Route exact path='/admin/companies' element={<Companies adminData={adminData}  companyID={companyID} branchID={branchID} />} />
                  <Route exact path='/admin/branches' element={<Branches />} />
                  <Route exact path='/admin/employee' element={<Employee />} />
                  <Route exact path='/admin/edit-company' element={<EditCompany />} />
                  {/* <Route exact path='/admin/edit-branch' element={<EditBranch/>} /> */}
                  <Route exact path='/admin/edit-branch' element={<EditBranch />} />
                  <Route exact path='/admin/edit-emp' element={<EditEmp />} />
                  <Route exact path='/admin/role' element={<Role />} />
                  <Route exact path='/admin/state' element={<State />} />
                  <Route exact path='/admin/party-master' element={<PartyMaster />} />
                  <Route exact path='/admin/account-master' element={<AccountMaster />} />
                    <Route exact path='/admin/financial-year-list' element={<FinancialYear />} />
                  <Route exact path='*' element={<PageNotFound />} />

                  {/* Daily Atytendecne check in check out  */}
                  <Route exact path='/admin/daily-attendence' element={<DailtAttendence adminData={adminData}/>}/>

                  {/* Inventory */}
                  <Route exact path='/admin/inventory' element={<Inventory adminData={adminData}  companyID={companyID} branchID={branchID} />} />
                  <Route exact path='/admin/materail-issue' element={<MaterialIssue adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/stock-transfer' element={<StockTransfer adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/po-requistion' element={<PORequistion adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/material-receipt' element={<MaterialReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/inventory-report' element={<Report/>}/>
                  <Route exact path='/admin/godown' element={<GodownMaster/>}/>
                  <Route exact path='/admin/inventory-detail' element={<PrintItemDetail/>}/>
                    <Route  exact path='/admin/inventory-document' element={<InventoryDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  
     
                  {/*Account  */}
                  <Route exact path='/admin/accounts' element={<Accounts adminData={adminData} />} />
                  <Route exact path='/admin/party' element={<PartyDetail adminData={adminData} />} />
                  <Route exact path='/admin/bank-payment' element={<BankPayment adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/cash-payment' element={<CashPayment adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                  <Route exact path='/admin/bank-receipt' element={<BankReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                  <Route exact path='/admin/cash-receipt' element={<CashReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                <Route exact path='/admin/credit-note' element={<CreditNode adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                <Route exact path='/admin/debit-note' element={<DebitNote adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route exact path='/admin/journal-voucher' element={<JournalVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route exact path='/admin/expnse-voucher' element={<ExpenseVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>  
                 <Route exact path='/admin/contra-voucher' element={<ContraVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
               <Route exact path='/admin/account-report' element={<AccountReport/>}/>
                <Route exact path='/admin/schedule' element={<Schedule/>}/>
                  <Route  exact path='/admin/account-document' element={<AccountDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/> 
                   <Route  exact path='/admin/bank-reconcilation' element={<BankReconcilation  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>   

                 
                 {/* Cost Center */}
                 <Route exact path='/admin/cost-center' element={<CostCenter adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                 <Route exact path='/admin/cost-category' element={<CostCategory adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                 <Route excat path='/admin/cost-center-link' element={<CostCenterLink adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
            
                  {/* hrms */}
                  <Route exact path='/admin/add-employee' element={<AddEmployee />} />
                  <Route exact path='/admin/add-holiday' element={<AddHoilday />} />
                  <Route exact path='/admin/leave-request' element={<LeaveRequest />} />
                  <Route exact path='/admin/loan' element={<Loan />} />
                  <Route exact path='/admin/notice-board' element={<NoticeBoard />} />
                    <Route exact path='/admin/hrms-report' element={<Report_hrms/>} />


                  {/* recruitment */}
                  
                  {/* <Route exact path='/admin/my-applications' element={<MyApplications />} /> */}
                  <Route exact path='/admin/post-openings' element={<PostOpening/>}/>
                  <Route exact path='/admin/my-applications' element={<MyApplications/>}/>
                
                  {/* documents */}
                 <Route exact path='/admin/hrms-document' element={<AllDocument />} />
                  {/* documents */}
                  <Route exact path='/admin/documents/salary-increment' element={<SalaryIncrement />} />
                  <Route exact path='/admin/documents/job-offer' element={<JobOffer />} />
                  <Route exact path='/admin/documents/confirmation' element={<Confirmation />} />
                  <Route exact path='/admin/documents/separation' element={<Separation />} />
                  <Route exact path='/admin/documents/appointment-letter' element={<Appointment />} />
                  <Route exact path='/admin/documents/posting' element={<Posting />} />
                  <Route exact path='/admin/documents/termination-notice' element={<TerminationNotice />} />
                  <Route exact path='/admin/documents/change-designation' element={<ChangeDesignation />} />
                  <Route exact path='/admin/documents/code-conduct' element={<CodeConduct />} />
                  <Route exact path='/admin/documents/disciplinary-warning' element={<DisciplinaryWarning />} />
                  <Route exact path='/admin/documents/appriciation' element={<Appriciation />} />
                  <Route exact path='/admin/documents/testimonial' element={<Testimonial />} />
                  <Route exact path='/admin/documents/advance' element={<Advance />} />
                  <Route exact path='/admin/documents/reference' element={<Reference />} />
           


                  {/* Attendance-route */}
                  <Route exact path='/admin/employee-attendance' element={<EmployeeA />} />
                  <Route exact path='/admin/emp-attendence' element={<EmployeeAttendence adminData={adminData} />} />
                  <Route exact path='/admin/attendence-report' element={<AttReport />} />


                  <Route exact path='/admin/pay-head' element={<PayHead />} />
                  <Route exact path='/admin/generate-payroll' element={<GenPayroll />} />
                  <Route exact path='/admin/monthwise-payhead-amounts' element={<PayheadAmt />} />
                   <Route exact path='/admin/payroll-report' element={<PayrollReport />} />
                 <Route exact path='/admin/payhead-report' element={<Payhead_Report />} />


                  {/* Attendance-route */}
                  <Route path='/admin/leave-master' element={<LeaveMaster />} />
                  <Route path='/admin/leave-application' element={<Leave />} />
                  <Route path='/admin/emp-attendence' element={<EmployeeAttendence  adminData={adminData}/>} />
                  <Route path='/admin/attendence-report' element={<AttReport />} />

                  {/* purchase  */}
                  <Route exact path='/admin/purchase' element={<Purchase adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/order' element={<Order adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  {/* <Route exact path='/admin/edit-purchase' element={<EditPurchase/>}/> */}
                  <Route exact path='/admin/purchase-enquiry' element={<Enquiry adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/quotation' element={<Quotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/purchase-return' element={<Return adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                   <Route  exact path='/admin/purchase-document' element={<PurchaseDocument  adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>  
                   
                 {/* Sales */}
                 <Route exact  path='/admin/performa-invoice' element={<PerformaInvoice adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                 <Route exact path='/admin/sale-invoice' element={<SaleInvoice  adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                 <Route exact path='/admin/sale-quotation' element={<SaleQuotation  adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                 <Route exact path='/admin/delivery-challan' element={<DeliveryChallan   adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/> 
                  <Route exact path='/admin/sale-return' element={<SaleReturn   adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />} />
                  <Route exxact path='/admin/charge-type' element={<ChargeMaster/>}/>
                  <Route  exact path='/admin/sale-report' element={<SaleReport/>}/>
                   <Route  exact path='/admin/sale-document' element={<SalesDocuments  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  


                   {/* Service */}
                  <Route exact path='/admin/complaint-type-master' element={<ComplaintTypeMaster adminData={adminData}  />} />
                   {/* =========================Services===================== */}
                  <Route exact path='/admin/crm/recharge' element={<Recharge />} />
                  <Route exact path='/admin/crm/complaint' element={<Complaint  adminData={adminData} companyID={companyID} branchID={branchID}financialYear={financialYear}/>} />
                <Route exact path='/admin/crm/vendor-call' element={<VendorCall adminData={adminData}/>} />
                  <Route path='/admin/crm/vendor-call/:status' element={<VendorCallStatusPage adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path ='/admin/repair-quoattaion' element={<RepairQuotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                 <Route exact path='/admin/repair-invoice' element={<RepairInvoice adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
             <Route  exact path='/admin/service-document' element={<ServiceDocuments  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  
             <Route  exact path='/admin/setting' element={<Setting  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>     
      

                  {/* CRM */}
                  <Route exa path='/admin/crm/followup-status' element={<FollowupStatus  />} />
                  <Route exact path='/admin/crm/followup' element={<FollowUp adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />} />
                  <Route exact path='/admin/crm/sales-enquiry' element={<SalesEnquiry adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/crm-bulk-data' element={<AddDataCall/>}/> 
                  <Route exact path='/admin/veried-call-list' element={<AllVerifiedCall/>}/>
                  <Route exact path='/admin/crm-report' element={<CRMReport/>}/>
                      <Route  exact path='/admin/crm-document' element={<CRMDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  

                   {/* Franchisee Admin */}
                   <Route path='/admin/denied-call' element={<DeniedCall  adminData={adminData} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/franchisee-area' element={<FranchiseeArea/>}/>
                
                {/* EMI */}
                    <Route path='/admin/party-emi' element={<Emi  adminData={adminData} branchID={branchID} financialYear={financialYear}/>}/>


                   {/* Customare Care  */}
                   <Route path='/admin/customer-care-detail' element={<CustomareCareDetail adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                    <Route exact path='/admin/call-verify' element={<CallDetail/>}/>
                    <Route exact path='/admin/customer-technician-verify' element={<Technician_Verify/>}/>

                    {/* Telle Caller  */}
                     <Route exact path='/admin/telecaller-call' element={<TelleCaller adminData={adminData} companyID={companyID} branchID={branchID} />}   />


                 {/* User Right */}
                 <Route exact path='/admin/user-right' element={<UserRight/>}/>

                 {/* Warranty */}
                 <Route path='/addmin/warranty' element={<Warranty adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route path='/admin/generate-pms' element={<ServiceSchedule adminData={adminData} companyID={companyID} branchID={branchID}  financialYear={financialYear}/>}/> 
                 <Route path='/admin/service-report-pms' element={<Service_ReportPMS/>}/> 
                 <Route path='/admin/warranty-report' element={<WarrantyReport  companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
             

                   {/* AMC */}
                   <Route path='/admin/amc' element={<AMC adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/amc-quotation' element={<AMCQuotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/amc-report' element={<AMC_Report />}/>
                      <Route  exact path='/admin/amc-document' element={<AMCDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  

                   {/* banner */}
                    <Route exact path='/admin/banner' element={<Banner/>}/>
                    {/* Coupon */}
                    <Route exact path='/admin/add-coupon' element={<Coupon/>}/>

                    {/* Message */}
                    <Route exact path='/admin/message-master' element={<MessageMaster/>}/>
                    <Route exact path='/admin/message-reminder' element={<ServiceReminder/>}/>
                   
                 {/* Production */}
                <Route path='/admin/batch-master' element={<Batch_master/>}/>
                 <Route path='/admin/bom-master' element={<Bom_master/>}/>
                <Route path='/admin/material-production' element={<Matrerial_issuee_Production adminData={adminData} companyID={companyID} branchID={branchID}/>}/>


                {/* Fixed Assets */}
                 <Route path='/admin/depreciation-method' element={<Deperecaition_Method/>}/>
                          <Route path='/admin/assets' element={<Assets/>}/>

               {/*Appraisal  */}
               <Route path='/admin/appraisal-parameter' element={<Appraisal_parameter/>}/>
                 <Route path='/admin/appraisal-rating' element={<AppraisalRating/>}/>
                <Route path='/admin/appraisal-type' element={<AppraisalType/>}/>
                <Route path='/admin/appraisal' element={<Appraisal adminData={adminData} />}/>

               {/* Manage Order */}
                <Route path='/admin/manage-order' element={<ManageOrder/>}/>

                {/* Contact us */}
                 <Route path='/admin/customer-enquiry' element={<Enquiry_From/>}/>

                 {/* Report */}
                 <Route path='/admin/pf-report' element={<PFReport  companyID={companyID} branchID={branchID}/>}/>
                  <Route path='/admin/costing-report' element={<CostingReport/>}/>

                 {/*HSN Master*/}
                   <Route exact path='/admin/hsn-master' element={<HSNCode adminData={adminData}/>} />
                      <Route exact path='/admin/group-master' element={<GroupMaster adminData={adminData}/>} />
                </>
              )}

              {/* admin-only routes  */}
              {role === 'subadmin' && (
                 <>
                  <Route exact path='/admin/companies' element={<Companies adminData={adminData}  companyID={companyID} branchID={branchID} />} />
                  <Route exact path='/admin/branches' element={<Branches />} />
                  <Route exact path='/admin/employee' element={<Employee />} />
                  <Route exact path='/admin/edit-company' element={<EditCompany />} />
                  {/* <Route exact path='/admin/edit-branch' element={<EditBranch/>} /> */}
                  <Route exact path='/admin/edit-branch' element={<EditBranch />} />
                  <Route exact path='/admin/edit-emp' element={<EditEmp />} />
                  <Route exact path='/admin/role' element={<Role />} />
                  <Route exact path='/admin/state' element={<State />} />
                  <Route exact path='/admin/party-master' element={<PartyMaster />} />
                  <Route exact path='/admin/account-master' element={<AccountMaster />} />
                  <Route exact path='*' element={<PageNotFound />} />

                  {/* Inventory */}
                  <Route exact path='/admin/inventory' element={<Inventory adminData={adminData}  companyID={companyID} branchID={branchID} />} />
                  <Route exact path='/admin/materail-issue' element={<MaterialIssue adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />} />
                  <Route exact path='/admin/stock-transfer' element={<StockTransfer adminData={adminData} />} />
                  <Route exact path='/admin/po-requistion' element={<PORequistion adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/material-receipt' element={<MaterialReceipt adminData={adminData} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/inventory-report' element={<Report/>}/>
                  <Route exact path='/admin/godown' element={<GodownMaster/>}/>
     
                  {/*Account  */}
                  <Route exact path='/admin/accounts' element={<Accounts adminData={adminData} />} />
                  <Route exact path='/admin/party' element={<PartyDetail adminData={adminData} />} />
                  <Route exact path='/admin/bank-payment' element={<BankPayment adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/cash-payment' element={<CashPayment adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                  <Route exact path='/admin/bank-receipt' element={<BankReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                  <Route exact path='/admin/cash-receipt' element={<CashReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                <Route exact path='/admin/credit-note' element={<CreditNode adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                <Route exact path='/admin/debit-note' element={<DebitNote adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route exact path='/admin/journal-voucher' element={<JournalVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route exact path='/admin/expnse-voucher' element={<ExpenseVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>  
                 <Route exact path='/admin/contra-voucher' element={<ContraVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
               <Route exact path='/admin/account-report' element={<AccountReport/>}/>
                <Route exact path='/admin/schedule' element={<Schedule/>}/>
                  <Route  exact path='/admin/account-document' element={<AccountDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/> 
                   <Route  exact path='/admin/bank-reconcilation' element={<BankReconcilation  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>   

                    {/* Cost Center */}
                 <Route exact path='/admin/cost-center' element={<CostCenter adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                 <Route exact path='/admin/cost-category' element={<CostCategory adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                 <Route excat path='/admin/cost-center-link' element={<CostCenterLink adminData={adminData} companyID={companyID} branchID={branchID}/>}/>

                  {/* hrms */}
                  <Route exact path='/admin/add-employee' element={<AddEmployee />} />
                  <Route exact path='/admin/add-holiday' element={<AddHoilday />} />
                  <Route exact path='/admin/leave-request' element={<LeaveRequest />} />
                  <Route exact path='/admin/loan' element={<Loan />} />
                  <Route exact path='/admin/notice-board' element={<NoticeBoard />} />

                     <Route exact path='/admin/post-openings' element={<PostOpening/>}/>
                  <Route exact path='/admin/my-applications' element={<MyApplications/>}/>
                
                  {/* documents */}
                 <Route exact path='/admin/hrms-document' element={<AllDocument />} />
                  {/* documents */}
                  <Route exact path='/admin/documents/salary-increment' element={<SalaryIncrement />} />
                  <Route exact path='/admin/documents/job-offer' element={<JobOffer />} />
                  <Route exact path='/admin/documents/confirmation' element={<Confirmation />} />
                  <Route exact path='/admin/documents/separation' element={<Separation />} />
                  <Route exact path='/admin/documents/appointment-letter' element={<Appointment />} />
                  <Route exact path='/admin/documents/posting' element={<Posting />} />
                  <Route exact path='/admin/documents/termination-notice' element={<TerminationNotice />} />
                  <Route exact path='/admin/documents/change-designation' element={<ChangeDesignation />} />
                  <Route exact path='/admin/documents/code-conduct' element={<CodeConduct />} />
                  <Route exact path='/admin/documents/disciplinary-warning' element={<DisciplinaryWarning />} />
                  <Route exact path='/admin/documents/appriciation' element={<Appriciation />} />
                  <Route exact path='/admin/documents/testimonial' element={<Testimonial />} />
                  <Route exact path='/admin/documents/advance' element={<Advance />} />
                  <Route exact path='/admin/documents/reference' element={<Reference />} />
           


                  {/* Attendance-route */}
                  <Route exact path='/admin/employee-attendance' element={<EmployeeA />} />
                  <Route exact path='/admin/emp-attendence' element={<EmployeeAttendence  adminData={adminData}/>} />
                  <Route exact path='/admin/attendence-report' element={<AttReport />} />


                  <Route exact path='/admin/pay-head' element={<PayHead />} />
                  <Route exact path='/admin/generate-payroll' element={<GenPayroll />} />
                  <Route exact path='/admin/monthwise-payhead-amounts' element={<PayheadAmt />} />
                  <Route exact path='/admin/payroll-report' element={<PayrollReport />} />
                   <Route exact path='/admin/payhead-report' element={<Payhead_Report />} />


                  {/* Attendance-route */}
                  <Route path='/admin/leave-master' element={<LeaveMaster />} />
                  <Route path='/admin/leave-application' element={<Leave />} />
                  <Route path='/admin/emp-attendence' element={<EmployeeAttendence adminData={adminData} />} />
                  <Route path='/admin/attendence-report' element={<AttReport />} />

                  {/* purchase  */}
                  <Route exact path='/admin/purchase' element={<Purchase adminData={adminData}  />} />
                  <Route exact path='/admin/order' element={<Order adminData={adminData}  />} />
                  {/* <Route exact path='/admin/edit-purchase' element={<EditPurchase/>}/> */}
                  <Route exact path='/admin/purchase-enquiry' element={<Enquiry adminData={adminData}  />} />
                  <Route exact path='/admin/quotation' element={<Quotation adminData={adminData}  />} />
                  <Route exact path='/admin/purchase-return' element={<Return adminData={adminData}  />} />
                                  <Route  exact path='/admin/purchase-document' element={<PurchaseDocument  adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>  
                   
                   
                 {/* Sales */}
                 <Route exact  path='/admin/performa-invoice' element={<PerformaInvoice adminData={adminData} companyID={companyID} branchID={branchID} />} />
                 <Route exact path='/admin/sale-invoice' element={<SaleInvoice adminData={adminData} companyID={companyID} branchID={branchID} />} />
                 <Route exact path='/admin/sale-quotation' element={<SaleQuotation  adminData={adminData}  companyID={companyID} branchID={branchID}/>} />
                 <Route exact path='/admin/delivery-challan' element={<DeliveryChallan  adminData={adminData} companyID={companyID} branchID={branchID}/>}/> 
                  <Route exact path='/admin/sale-return' element={<SaleReturn  adminData={adminData}/>} companyID={companyID} branchID={branchID} />
                  <Route exxact path='/admin/charge-type' element={<ChargeMaster/>}/>
                    <Route  exact path='/admin/sale-document' element={<SalesDocuments  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  



                   {/* Service */}
                  <Route exact path='/admin/complaint-type-master' element={<ComplaintTypeMaster adminData={adminData}  />} />
                   {/* =========================Services===================== */}
                  <Route exact path='/admin/crm/recharge' element={<Recharge />} />
                  <Route exact path='/admin/crm/complaint' element={<Complaint adminData={adminData} companyID={companyID} branchID={branchID}financialYear={financialYear} />} />
                  <Route exact path='/admin/crm/vandor-call' element={<VendorCall />} />
                  <Route path='/admin/crm/vendor-call/:status' element={<VendorCallStatusPage adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path ='/admin/repair-quoattaion' element={<RepairQuotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                 <Route exact path='/admin/repair-invoice' element={<RepairInvoice adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
             <Route  exact path='/admin/service-document' element={<ServiceDocuments  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  


                  {/* CRM */}
                  <Route exa path='/admin/crm/followup-status' element={<FollowupStatus  />} />
                  <Route exact path='/admin/crm/followup' element={<FollowUp adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />} />
                  <Route exact path='/admin/crm/sales-enquiry' element={<SalesEnquiry adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/crm-bulk-data' element={<AddDataCall/>}/> 
                  <Route exact path='/admin/veried-call-list' element={<AllVerifiedCall/>}/>
                  <Route exact path='/admin/crm-report' element={<CRMReport/>}/>
                      <Route  exact path='/admin/crm-document' element={<CRMDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  
                
                {/* Franchisee Admin */}
                   <Route path='/admin/denied-call' element={<DeniedCall  adminData={adminData} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/franchisee-area' element={<FranchiseeArea/>}/>


                    {/* Customare Care  */}
                   <Route path='/admin/customer-care-detail' element={<CustomareCareDetail adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                    <Route exact path='/admin/call-verify' element={<CallDetail/>}/>
                    <Route exact path='/admin/customer-technician-verify' element={<Technician_Verify/>}/>

                    {/* Telle Caller  */}
                     <Route exact path='/admin/telecaller-call' element={<TelleCaller adminData={adminData} companyID={companyID} branchID={branchID} />}   />

               
                 {/* Warranty */}
                 <Route path='/addmin/warranty' element={<Warranty adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route path='/admin/generate-pms' element={<ServiceSchedule adminData={adminData} companyID={companyID} branchID={branchID}  financialYear={financialYear}/>}/> 
                 <Route path='/admin/service-report-pms' element={<Service_ReportPMS/>}/> 
                 <Route path='/admin/warranty-report' element={<WarrantyReport  companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
             

                   {/* AMC */}
                   <Route path='/admin/amc' element={<AMC adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/amc-quotation' element={<AMCQuotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/amc-report' element={<AMC_Report />}/>
                      <Route  exact path='/admin/amc-document' element={<AMCDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  




                {/* Banner */}
                <Route exact path='/admin/banner' element={<Banner/>}/>
                     
                      {/* Telecaller */}
                       <Route exact path='/admin/telecaller-call' element={<TelleCaller adminData={adminData}/>}   />
                </>
              )}

                {role === 'employee' && (
                <>
                  <Route exact path='/admin/companies' element={<Companies adminData={adminData}  companyID={companyID} branchID={branchID} />} />
                  <Route exact path='/admin/branches' element={<Branches />} />
                  <Route exact path='/admin/employee' element={<Employee />} />
                  <Route exact path='/admin/edit-company' element={<EditCompany />} />
                  {/* <Route exact path='/admin/edit-branch' element={<EditBranch/>} /> */}
                  <Route exact path='/admin/edit-branch' element={<EditBranch />} />
                  <Route exact path='/admin/edit-emp' element={<EditEmp />} />
                  <Route exact path='/admin/role' element={<Role />} />
                  <Route exact path='/admin/state' element={<State />} />
                  <Route exact path='/admin/party-master' element={<PartyMaster />} />
                  <Route exact path='/admin/account-master' element={<AccountMaster />} />
                  <Route exact path='*' element={<PageNotFound />} />

                  {/* Inventory */}
                  <Route exact path='/admin/inventory' element={<Inventory adminData={adminData}  companyID={companyID} branchID={branchID} />} />
                  <Route exact path='/admin/materail-issue' element={<MaterialIssue adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />} />
                  <Route exact path='/admin/stock-transfer' element={<StockTransfer adminData={adminData} />} />
                  <Route exact path='/admin/po-requistion' element={<PORequistion adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/material-receipt' element={<MaterialReceipt adminData={adminData} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/inventory-report' element={<Report/>}/>
                  <Route exact path='/admin/godown' element={<GodownMaster/>}/>
     
                  {/*Account  */}
                  <Route exact path='/admin/accounts' element={<Accounts adminData={adminData} />} />
                  <Route exact path='/admin/party' element={<PartyDetail adminData={adminData} />} />
                  <Route exact path='/admin/bank-payment' element={<BankPayment adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                  <Route exact path='/admin/cash-payment' element={<CashPayment adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                  <Route exact path='/admin/bank-receipt' element={<BankReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                  <Route exact path='/admin/cash-receipt' element={<CashReceipt adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                <Route exact path='/admin/credit-note' element={<CreditNode adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                <Route exact path='/admin/debit-note' element={<DebitNote adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route exact path='/admin/journal-voucher' element={<JournalVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route exact path='/admin/expnse-voucher' element={<ExpenseVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>  
                 <Route exact path='/admin/contra-voucher' element={<ContraVoucher adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
               <Route exact path='/admin/account-report' element={<AccountReport/>}/>
                <Route exact path='/admin/schedule' element={<Schedule/>}/>
                  <Route  exact path='/admin/account-document' element={<AccountDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/> 
                   <Route  exact path='/admin/bank-reconcilation' element={<BankReconcilation  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>   

                    {/* Cost Center */}
                 <Route exact path='/admin/cost-center' element={<CostCenter adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                 <Route exact path='/admin/cost-category' element={<CostCategory adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                 <Route excat path='/admin/cost-center-link' element={<CostCenterLink adminData={adminData} companyID={companyID} branchID={branchID}/>}/>

                  {/* hrms */}
                  <Route exact path='/admin/add-employee' element={<AddEmployee />} />
                  <Route exact path='/admin/add-holiday' element={<AddHoilday />} />
                  <Route exact path='/admin/leave-request' element={<LeaveRequest />} />
                  <Route exact path='/admin/loan' element={<Loan />} />
                  <Route exact path='/admin/notice-board' element={<NoticeBoard />} />

                     <Route exact path='/admin/post-openings' element={<PostOpening/>}/>
                  <Route exact path='/admin/my-applications' element={<MyApplications/>}/>
                
                  {/* documents */}
                 <Route exact path='/admin/hrms-document' element={<AllDocument />} />
                  {/* documents */}
                  <Route exact path='/admin/documents/salary-increment' element={<SalaryIncrement />} />
                  <Route exact path='/admin/documents/job-offer' element={<JobOffer />} />
                  <Route exact path='/admin/documents/confirmation' element={<Confirmation />} />
                  <Route exact path='/admin/documents/separation' element={<Separation />} />
                  <Route exact path='/admin/documents/appointment-letter' element={<Appointment />} />
                  <Route exact path='/admin/documents/posting' element={<Posting />} />
                  <Route exact path='/admin/documents/termination-notice' element={<TerminationNotice />} />
                  <Route exact path='/admin/documents/change-designation' element={<ChangeDesignation />} />
                  <Route exact path='/admin/documents/code-conduct' element={<CodeConduct />} />
                  <Route exact path='/admin/documents/disciplinary-warning' element={<DisciplinaryWarning />} />
                  <Route exact path='/admin/documents/appriciation' element={<Appriciation />} />
                  <Route exact path='/admin/documents/testimonial' element={<Testimonial />} />
                  <Route exact path='/admin/documents/advance' element={<Advance />} />
                  <Route exact path='/admin/documents/reference' element={<Reference />} />
           


                  {/* Attendance-route */}
                  <Route exact path='/admin/employee-attendance' element={<EmployeeA />} />
                  <Route exact path='/admin/emp-attendence' element={<EmployeeAttendence  adminData={adminData}/>} />
                  <Route exact path='/admin/attendence-report' element={<AttReport />} />


                  <Route exact path='/admin/pay-head' element={<PayHead />} />
                  <Route exact path='/admin/generate-payroll' element={<GenPayroll />} />
                  <Route exact path='/admin/monthwise-payhead-amounts' element={<PayheadAmt />} />
                  <Route exact path='/admin/payroll-report' element={<PayrollReport />} />
                   <Route exact path='/admin/payhead-report' element={<Payhead_Report />} />


                  {/* Attendance-route */}
                  <Route path='/admin/leave-master' element={<LeaveMaster />} />
                  <Route path='/admin/leave-application' element={<Leave />} />
                  <Route path='/admin/emp-attendence' element={<EmployeeAttendence adminData={adminData} />} />
                  <Route path='/admin/attendence-report' element={<AttReport />} />

                  {/* purchase  */}
                  <Route exact path='/admin/purchase' element={<Purchase adminData={adminData}  />} />
                  <Route exact path='/admin/order' element={<Order adminData={adminData}  />} />
                  {/* <Route exact path='/admin/edit-purchase' element={<EditPurchase/>}/> */}
                  <Route exact path='/admin/purchase-enquiry' element={<Enquiry adminData={adminData}  />} />
                  <Route exact path='/admin/quotation' element={<Quotation adminData={adminData}  />} />
                  <Route exact path='/admin/purchase-return' element={<Return adminData={adminData}  />} />
                                  <Route  exact path='/admin/purchase-document' element={<PurchaseDocument  adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>  
                   
                   
                 {/* Sales */}
                 <Route exact  path='/admin/performa-invoice' element={<PerformaInvoice adminData={adminData} companyID={companyID} branchID={branchID} />} />
                 <Route exact path='/admin/sale-invoice' element={<SaleInvoice adminData={adminData} companyID={companyID} branchID={branchID} />} />
                 <Route exact path='/admin/sale-quotation' element={<SaleQuotation  adminData={adminData}  companyID={companyID} branchID={branchID}/>} />
                 <Route exact path='/admin/delivery-challan' element={<DeliveryChallan  adminData={adminData} companyID={companyID} branchID={branchID}/>}/> 
                  <Route exact path='/admin/sale-return' element={<SaleReturn  adminData={adminData}/>} companyID={companyID} branchID={branchID} />
                  <Route exxact path='/admin/charge-type' element={<ChargeMaster/>}/>
                    <Route  exact path='/admin/sale-document' element={<SalesDocuments  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  



                   {/* Service */}
                  <Route exact path='/admin/complaint-type-master' element={<ComplaintTypeMaster adminData={adminData}  />} />
                   {/* =========================Services===================== */}
                  <Route exact path='/admin/crm/recharge' element={<Recharge />} />
                  <Route exact path='/admin/crm/complaint' element={<Complaint adminData={adminData} companyID={companyID} branchID={branchID}financialYear={financialYear} />} />
                  <Route exact path='/admin/crm/vandor-call' element={<VendorCall />} />
                  <Route path='/admin/crm/vendor-call/:status' element={<VendorCallStatusPage adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path ='/admin/repair-quoattaion' element={<RepairQuotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                 <Route exact path='/admin/repair-invoice' element={<RepairInvoice adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
             <Route  exact path='/admin/service-document' element={<ServiceDocuments  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  


                  {/* CRM */}
                  <Route exa path='/admin/crm/followup-status' element={<FollowupStatus  />} />
                  <Route exact path='/admin/crm/followup' element={<FollowUp adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />} />
                  <Route exact path='/admin/crm/sales-enquiry' element={<SalesEnquiry adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
                  <Route exact path='/admin/crm-bulk-data' element={<AddDataCall/>}/> 
                  <Route exact path='/admin/veried-call-list' element={<AllVerifiedCall/>}/>
                  <Route exact path='/admin/crm-report' element={<CRMReport/>}/>
                      <Route  exact path='/admin/crm-document' element={<CRMDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  
                
                {/* Franchisee Admin */}
                   <Route path='/admin/denied-call' element={<DeniedCall  adminData={adminData} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/franchisee-area' element={<FranchiseeArea/>}/>


                    {/* Customare Care  */}
                   <Route path='/admin/customer-care-detail' element={<CustomareCareDetail adminData={adminData} companyID={companyID} branchID={branchID}/>}/>
                    <Route exact path='/admin/call-verify' element={<CallDetail/>}/>
                    <Route exact path='/admin/customer-technician-verify' element={<Technician_Verify/>}/>

                    {/* Telle Caller  */}
                     <Route exact path='/admin/telecaller-call' element={<TelleCaller adminData={adminData} companyID={companyID} branchID={branchID} />}   />

               
                 {/* Warranty */}
                 <Route path='/addmin/warranty' element={<Warranty adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear} />}/>
                 <Route path='/admin/generate-pms' element={<ServiceSchedule adminData={adminData} companyID={companyID} branchID={branchID}  financialYear={financialYear}/>}/> 
                 <Route path='/admin/service-report-pms' element={<Service_ReportPMS/>}/> 
                 <Route path='/admin/warranty-report' element={<WarrantyReport  companyID={companyID} branchID={branchID} financialYear={financialYear}/>} />
             

                   {/* AMC */}
                   <Route path='/admin/amc' element={<AMC adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/amc-quotation' element={<AMCQuotation adminData={adminData} companyID={companyID} branchID={branchID} financialYear={financialYear}/>}/>
                   <Route path='/admin/amc-report' element={<AMC_Report />}/>
                      <Route  exact path='/admin/amc-document' element={<AMCDocument  adminData={adminData} companyID={companyID} branchID={branchID}/>}/>  




                {/* Banner */}
                <Route exact path='/admin/banner' element={<Banner/>}/>
                     
                      {/* Telecaller */}
                       <Route exact path='/admin/telecaller-call' element={<TelleCaller adminData={adminData}/>}   />
                  
                  {/* HSn code master */}
                   <Route exact path='/admin/hsn-master' element={<HSNCode adminData={adminData}/>}   />
          
                </>

                
              )}

            </Routes>
          </>
        )}
      </LoadingProvider>
     
    </>
  );
};

export default App;
